import GtinFetchModal from "./GtinFetchModal";

export default GtinFetchModal;
